// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"b7bca13c95930378e050","303":"f6f32ae92d113ed6b372","495":"ad197b0f299418d86c9a"}[chunkId] + ".js";
};